export default {
  get cover() {
    if (this.images) {
      if (this.images.pc && this.images.pc.length) {
        return {
          url: this.images.pc[0].mainUrl,
          mini: this.images.pc[0].miniUrl,
          source: this.images.pc[0].source,
        };
      }
    }

    if (this.artworks) {
      if (this.artworks.pc && this.artworks.pc.length) {
        return {
          url: this.artworks.pc[0].mainUrl,
          mini: this.artworks.pc[0].miniUrl,
          source: this.artworks.pc[0].source,
        };
      }
    }

    return {};
  },
};
